import React from 'react';
import { Grid, Typography } from '@mui/material';
import BackButton from 'components/Button';

const styles = {
    root: {
        p: 3,
        width: '60%',
    },
    section: {
        mb: 4,
    },
    title: {
        mb: 2,
        fontWeight: 'bold',
    },
    content: {
        mb: 2,
    },
    backButton: {
        mt: 2,
        justifyContent: 'center',
        display: 'flex',
    },
};

const ProgramaProVida = () => {

    return (
        <Grid container style={{ justifyContent: 'center' }}>
            <Grid sx={styles.root}>
                <Grid item xs={12} sx={styles.section}>
                    <Typography variant="h4" sx={styles.title}>
                        Combate às Drogas - Programa PróVida
                    </Typography>
                    <Typography variant="body1" sx={styles.content}>
                        <strong>Data:</strong> Segunda, 12 de maio de 2014
                    </Typography>
                    <Typography variant="body1" sx={styles.content}>
                        <strong>Município:</strong> Cataguases, Município de Cataguases/MG
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={styles.section}>
                    <Typography variant="h5" sx={styles.title}>
                        Identificação do Município
                    </Typography>
                    <Typography variant="body1" sx={styles.content}>
                        O Município, de 73.232 habitantes, localiza-se na Mesorregião da Zona da Mata mineira, sendo muito conhecido por seu parque industrial. Destacam-se os setores de tecelagem, reciclagem de papéis, mineração, manufatura de algodão, dentre outros.
                        Além de considerada cidade histórica, gravou seu nome no cinema nos anos 1920, e alcançou grande repercussão no Movimento Moderno de arquitetura na década de 1940.
                        Atualmente, Cataguases mantém o perfil de cidade do cinema, realizando anualmente o Festival Ver e Fazer Filmes, que conta com a participação de produtores convidados de várias partes do país e do exterior para a produção e a exibição de curtas.
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={styles.section}>
                    <Typography variant="h5" sx={styles.title}>
                        Ação
                    </Typography>
                    <Typography variant="body1" sx={styles.content}>
                        A prefeitura municipal, juntamente com a Secretaria de Assistência Social, implantou o Programa PróVida – um projeto voltado à prevenção ao uso e abuso de drogas e principalmente de valorização da vida.
                        O trabalho é desenvolvido desde 2001 com o propósito de fortalecer as equipes internas das escolas, como também outras entidades e instituições que tenham como público crianças, adolescentes e jovens.
                        Na expectativa de intervir nas famílias de forma positiva, avançando na direção de mudanças favoráveis em relação aos indicadores de vulnerabilidade e riscos sociais aos quais ainda são expostos crianças e  adolescentes, uma releitura do projeto foi realizada, agregando novos integrantes: Centros de Referência de Assistência Social, Programas Sociais que atendam a crianças e jovens, Associações de Bairro e ONGs.
                        Dentre as ações que foram desenvolvidas, destacam-se: oficinas, palestras, campanhas socioeducativas, teatro, reflexões sobre o Estatuto da Criança e do Adolescente, Festival da Canção – Fest Vida, dentre outras.
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={styles.section}>
                    <Typography variant="h5" sx={styles.title}>
                        Resultados
                    </Typography>
                    <Typography variant="body1" sx={styles.content}>
                        - Experiências que possibilitam o desenvolvimento e a ampliação do universo informacional e cultural dos cidadãos.
                        - Protagonismo das crianças e dos jovens quanto ao envolvimento nas discussões.
                        - Elevação da autoestima dos envolvidos.
                        - Fortalecimento da autonomia e cidadania das crianças e jovens.
                        - Articulação das redes locais no combate e prevenção ao uso de drogas.
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={styles.section}>
                    <Typography variant="h5" sx={styles.title}>
                        Recursos
                    </Typography>
                    <Typography variant="body1" sx={styles.content}>
                        O projeto é financiado pelo Fundo Municipal dos Direitos da Criança e do Adolescente, bancos particulares instalados no Município e pela Prefeitura Municipal de Cataguases por meio dos recursos da Proteção Social Básica.
                        O valor aproximado investido por ano é de R$ 55 mil.
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={styles.backButton}>
                   <BackButton />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default ProgramaProVida;
